import { render } from "./SocialsSection.vue?vue&type=template&id=5e3c72c9&scoped=true"
import script from "./SocialsSection.vue?vue&type=script&lang=js"
export * from "./SocialsSection.vue?vue&type=script&lang=js"

import "./SocialsSection.vue?vue&type=style&index=0&id=5e3c72c9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3c72c9"]])

export default __exports__